import React from "react";
import Count from "../../common/count";

const CounterUp = () => {
    return (
        <section className="counter__one section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="counter__one-area">

                            <div className="counter__one-area-item">
                                <h2>
                                    <Count number={500} />+
                                </h2>
                                <p>Complete Projects</p>
                            </div>

                            <div className="counter__one-area-item">
                                <h2>
                                    <Count number={100} />+
                                </h2>
                                <p>Team Members</p>
                            </div>

                            <div className="counter__one-area-item">
                                <h2>
                                    <Count number={500} />+
                                </h2>
                                <p>Client Reviews</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CounterUp;
